module.exports = __webpack_public_path__ + "static/img/IMG_20150307_182207.261dadf2.jpg";